import React from 'react';
import './Experience.css';

const jobs = [
  {
    title: 'Growth Executive',
    company: 'Hackathons Canada',
    date: '2025 – 2026',
    bullets: [
      'Secured sponsorships from Google and Microsoft for one of North America\'s largest hackathon communities.',
      'Organized Hack Canada, hosting 400+ students and coordinating logistics, partnerships, and event execution.',
    ],
  },
  {
    title: 'SAP FICO Quality Assurance',
    company: '13875561 Canada Inc.',
    date: '2025 – 2026',
    bullets: [
      'Tested SAP S/4HANA Finance modules for enterprise clients including CN Rail and Domtar.',
      'Executed 30+ test cases validating financial transactions, banking interfaces, and SAP Fiori apps.',
      'Identified and reproduced 20+ defects, collaborating with developers to verify fixes.',
    ],
  },
  {
    title: 'Assistant Teacher',
    company: 'Spirit of Math',
    date: '2021 – 2022',
    bullets: [
      'Led mental math sessions for 20+ students, improving speed and accuracy.',
      'Evaluated 50+ weekly assessments and provided structured feedback.',
    ],
  },
];

export default function Experience() {
  return (
    <section id="experience" className="experience">
      <div className="container">
        <p className="section-label">Experience</p>
        <h2 className="section-title">Where I've Worked</h2>
        <div className="exp-list">
          {jobs.map((job) => (
            <div key={job.company} className="exp-item">
              <div className="exp-header">
                <div>
                  <h3 className="exp-title">{job.title}</h3>
                  <span className="exp-company">{job.company}</span>
                </div>
                <span className="exp-date">{job.date}</span>
              </div>
              <ul className="exp-bullets">
                {job.bullets.map((b, i) => (
                  <li key={i}>{b}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
